import React, { useEffect, useMemo, useState } from "react";
// Pastikan path ke bootstrap Anda sudah benar
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from 'react-toastify';
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

// Import services for MasterPaket and MasterJenisSeleksi, MasterTipeKonten
import {
  fetchPaket,
  createPaket,
  updatePaket,
  deletePaket,
} from '../../../services/Master/MasterPaket';
import { fetchJenisSeleksi } from '../../../services/Master/MasterJenisSeleksi'; // Service ini yang sudah disesuaikan
import { fetchTipeKonten } from '../../../services/Master/MasterTipeKonten';

// Import components
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import DeleteModal from '../../../components/Common/DeleteModal';

const MasterPaket = () => {
  // Meta title
  document.title = "Master Paket";

  // State management
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [paket, setPaket] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingJenisSeleksiOptions, setLoadingJenisSeleksiOptions] = useState(false);
  const [loadingTipeKontenOptions, setLoadingTipeKontenOptions] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    per_page: 10,
    total: 0,
    last_page: 1
  });
  const [filters, setFilters] = useState({
    nama_paket: "",
    id_jenis_seleksi: "",
    id_tipe_konten: "",
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [jenisSeleksiOptions, setJenisSeleksiOptions] = useState([]);
  const [tipeKontenOptions, setTipeKontenOptions] = useState([]);

  // Fungsi untuk menutup modal konfirmasi hapus
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setPaket(null);
  };

  // Fungsi untuk mengkonfirmasi dan menghapus data paket
  const handleConfirmDelete = async () => {
    try {
      if (paket && paket.id_paket) {
        const response = await deletePaket(paket.id_paket);
        if (response.success) {
          toast.success("Paket berhasil dihapus");
          fetchData(pagination.page, pagination.per_page, filters);
        } else {
          toast.error(response.message || "Gagal menghapus Paket");
        }
      }
    } catch (error) {
      console.error("Error deleting Paket:", error);
      toast.error(error.message || "Gagal menghapus Paket");
    } finally {
      handleCloseDeleteModal();
    }
  };

  // Fungsi untuk mengambil data daftar paket dari API (dengan pagination)
  const fetchData = async (page = 1, per_page = 10, filterParams = {}) => {
    try {
      setLoading(true);
      const response = await fetchPaket({
        page,
        per_page,
        filters: filterParams
      });

      setData(response.data || []);
      setPagination({
        page: response.meta?.page || 1,
        per_page: response.meta?.per_page || 10,
        total: response.meta?.total || 0,
        last_page: response.meta?.last_page || Math.ceil((response.meta?.total || 0) / (response.meta?.per_page || 10))
      });
    } catch (error) {
      console.error("Error in fetchData:", error);
      toast.error("Gagal memuat data Paket");
    } finally {
      setLoading(false);
    }
  };

  // Fungsi untuk mengambil semua data jenis seleksi tanpa pagination (untuk dropdown id_jenis_seleksi)
  const fetchJenisSeleksiOptions = async (tipeKontenId) => {
    try {
  
      setLoadingJenisSeleksiOptions(true);
      const params = { disable_pagination: true };
      if (tipeKontenId) {
        params.id_tipe_konten = tipeKontenId;

      }
      // Jika tipeKontenId null, `params.filters` tidak akan ada, dan service akan mengembalikan semua
      console.log("Calling fetchJenisSeleksi with params:", params); // DEBUG LOG
      const response = await fetchJenisSeleksi(params);

      if (response && response.data) {
        setJenisSeleksiOptions(response.data);
      } else {
        toast.error("Gagal memuat opsi jenis seleksi: struktur respons tidak valid");
      }
    } catch (error) {
      console.error("Error fetching jenis seleksi options:", error);
      toast.error("Terjadi kesalahan saat memuat opsi jenis seleksi.");
    } finally {
      setLoadingJenisSeleksiOptions(false);
    }
  };

  // Fungsi untuk mengambil semua data tipe konten tanpa pagination (untuk dropdown id_tipe_konten)
  const fetchTipeKontenOptions = async () => {
    try {
      setLoadingTipeKontenOptions(true);
      const response = await fetchTipeKonten();

      if (response && response.data) {
        setTipeKontenOptions(response.data);
      } else {
        toast.error("Gagal memuat opsi tipe konten: struktur respons tidak valid");
      }
    } catch (error) {
      console.error("Error fetching tipe konten options:", error);
      toast.error("Terjadi kesalahan saat memuat opsi tipe konten.");
    } finally {
      setLoadingTipeKontenOptions(false);
    }
  };

  // Konfigurasi validasi form menggunakan Formik dan Yup
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      nama_paket: paket?.nama_paket || "",
      deskripsi: paket?.deskripsi || "",
      gambar_url: paket?.gambar_url || "",
      durasi_menit: paket?.durasi_menit || "",
      is_premium: paket?.is_premium ?? false,
      id_jenis_seleksi: paket?.id_jenis_seleksi === null ? "" : (paket?.id_jenis_seleksi || ""),
      id_tipe_konten: paket?.id_tipe_konten === null ? "" : (paket?.id_tipe_konten || ""),
      url_video: paket?.paket_detail_video?.url_video || "",
      durasi_detik: paket?.paket_detail_video?.durasi_detik || "",
      thumbnail_url: paket?.paket_detail_video?.thumbnail_url || "",
    },

    validationSchema: Yup.object({
      nama_paket: Yup.string().required("Nama Paket wajib diisi"),
      deskripsi: Yup.string().nullable(),
      gambar_url: Yup.string().nullable().url("Format URL gambar tidak valid"),
      durasi_menit: Yup.number()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value))
        .min(0, "Durasi Menit tidak boleh negatif")
        .test(
          'is-integer',
          'Durasi Menit harus bilangan bulat',
          value => value === null || Number.isInteger(value)
        ),
      is_premium: Yup.boolean().required("Status Premium wajib diisi"),
      id_jenis_seleksi: Yup.number()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value)),
      id_tipe_konten: Yup.number()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value)),
    }),

    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        formData.append('nama_paket', String(values.nama_paket || ''));
        formData.append('deskripsi', String(values.deskripsi || ''));
        formData.append('gambar_url', String(values.gambar_url || ''));

        if (values.durasi_menit !== null && values.durasi_menit !== '') {
          formData.append('durasi_menit', String(values.durasi_menit));
        } else {
          formData.append('durasi_menit', '');
        }
        formData.append('is_premium', values.is_premium ? '1' : '0');

        if (values.id_jenis_seleksi !== null && values.id_jenis_seleksi !== '') {
          formData.append('id_jenis_seleksi', String(values.id_jenis_seleksi));
        } else {
          formData.append('id_jenis_seleksi', '');
        }

        if (values.id_tipe_konten !== null && values.id_tipe_konten !== '') {
          formData.append('id_tipe_konten', String(values.id_tipe_konten));
        } else {
          formData.append('id_tipe_konten', '');
        }

        switch (parseInt(values.id_tipe_konten)) {
          case 3: // Video
            formData.append('url_video', String(values.url_video || ''));
            formData.append('durasi_detik', String(values.durasi_detik || ''));
            formData.append('thumbnail_url', String(values.thumbnail_url || ''));
            break;
          // ... case untuk tipe konten lain
        }

        let response;
        if (isEdit) {
          response = await updatePaket(paket.id_paket, formData);
        } else {
          response = await createPaket(formData);
        }

        if (response.success) {
          toast.success(response.message || (isEdit ? "Paket berhasil diperbarui" : "Paket berhasil ditambahkan"));
          setModal(false);
          // Panggil fetchData setelah setModal(false) agar data diperbarui setelah modal ditutup
          fetchData(pagination.page, pagination.per_page, filters);
        } else {
          if (response.errors) {
            Object.keys(response.errors).forEach(key => {
              response.errors[key].forEach(msg => {
                toast.error(`${key}: ${msg}`);
              });
            });
          } else if (response.code === 409) {
            toast.error(response.message || "Nama Paket sudah ada. Mohon gunakan nama lain.");
          } else {
            toast.error(response.message || "Gagal menyimpan Paket");
          }
        }
      } catch (error) {
        console.error("Error in form submission:", error);
        if (error.response && error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
        } else if (error.response && error.response.data && error.response.data.errors) {
          Object.keys(error.response.data.errors).forEach(key => {
            error.response.data.errors[key].forEach(msg => {
              toast.error(`${key}: ${msg}`);
            });
          });
        } else {
          toast.error("Terjadi kesalahan saat menyimpan data.");
        }
      }
    },
  });

  // Efek samping untuk memuat data awal saat komponen dimuat
  useEffect(() => {
    fetchData(1, pagination.per_page, filters);
    fetchTipeKontenOptions(); // Hanya memuat tipe konten di awal
  }, []);

  // Efek samping untuk memuat opsi jenis seleksi saat modal dibuka atau id_tipe_konten di form berubah
  // Ini akan mencegah pemanggilan API ganda dari onChange
  useEffect(() => {
    // Pastikan modal terbuka dan validation object tersedia
    if (modal && validation) {
      const selectedTipeKontenId = validation.values.id_tipe_konten;
      console.log("DEBUG: useEffect triggered for Jenis Seleksi. id_tipe_konten:", selectedTipeKontenId); // DEBUG LOG
      fetchJenisSeleksiOptions(selectedTipeKontenId || null);
    }
  }, [modal, validation?.values.id_tipe_konten]); // Dependensi: modal dan nilai id_tipe_konten dari formik

  // Handle perubahan filter input
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const newFilters = {
      ...filters,
      [name]: value
    };

    // Jika filter id_tipe_konten berubah, muat ulang opsi jenis seleksi untuk filter
    if (name === "id_tipe_konten") {
      // Jika id_tipe_konten di filter diubah, set id_jenis_seleksi di filter menjadi kosong
      newFilters.id_jenis_seleksi = "";
      console.log("DEBUG: Filter id_tipe_konten changed, updating Jenis Seleksi filter options."); // DEBUG LOG
      fetchJenisSeleksiOptions(value || null); // Panggil ulang dengan ID tipe konten yang baru
    }

    setFilters(newFilters);
    fetchData(1, pagination.per_page, newFilters);
  };

  // Fungsi untuk menghapus semua filter
  const clearFilters = () => {
    const defaultFilters = {
      nama_paket: "",
      id_jenis_seleksi: "",
      id_tipe_konten: "",
    };
    setFilters(defaultFilters);
    fetchData(1, pagination.per_page, defaultFilters);
    // Saat filter dibersihkan, muat ulang semua jenis seleksi
    fetchJenisSeleksiOptions();
    console.log("DEBUG: Filters cleared, fetching all Jenis Seleksi options."); // DEBUG LOG
  };

  // Fungsi untuk membuka modal tambah
  const openAddModal = () => {
    setPaket(null);
    setIsEdit(false);
    validation.resetForm();
    // Kosongkan nilai id_tipe_konten dan id_jenis_seleksi saat membuka modal tambah
    // Ini akan memicu useEffect di atas untuk memuat semua jenis seleksi
    validation.setFieldValue("id_tipe_konten", "");
    validation.setFieldValue("id_jenis_seleksi", "");
    setModal(true);
    console.log("DEBUG: Opening Add Modal. Form values reset."); // DEBUG LOG
  };

  // Fungsi untuk membuka modal edit
  const openEditModal = (paketData) => {
    setPaket(paketData);
    setIsEdit(true);
    // Set nilai formik saat edit
    validation.setValues({
      nama_paket: paketData.nama_paket || "",
      deskripsi: paketData.deskripsi || "",
      gambar_url: paketData.gambar_url || "",
      durasi_menit: paketData.durasi_menit || "",
      is_premium: paketData.is_premium ?? false,
      id_jenis_seleksi: paketData.id_jenis_seleksi === null ? "" : (paketData.id_jenis_seleksi || ""),
      id_tipe_konten: paketData.id_tipe_konten === null ? "" : (paketData.id_tipe_konten || ""),
      url_video: paketData.paket_detail_video?.url_video || "",
      durasi_detik: paketData.paket_detail_video?.durasi_detik || "",
      thumbnail_url: paketData.paket_detail_video?.thumbnail_url || "",
    });
    // useEffect di atas akan menangani pemuatan jenis seleksi berdasarkan paketData.id_tipe_konten
    setModal(true);
    console.log("DEBUG: Opening Edit Modal. Pre-populating form with:", paketData); // DEBUG LOG
  };

  // Fungsi saat tombol delete di klik
  const onClickDelete = (paketData) => {
    setPaket(paketData);
    setDeleteModal(true);
  };

  // Definisi kolom tabel
  const columns = useMemo(
    () => [
      {
        header: "Nama Paket",
        accessorKey: "nama_paket",
        enableColumnFilter: false,
      },
      {
        header: "Tipe Konten",
        accessorKey: "tipe_konten.tipe_konten",
        enableColumnFilter: false,
        cell: (cellProps) => {
          return cellProps.row.original.tipe_konten ? cellProps.row.original.tipe_konten.tipe_konten : "-";
        }
      },
      {
        header: "Durasi (Menit)",
        accessorKey: "durasi_menit",
        enableColumnFilter: false,
        cell: (cellProps) => {
          return cellProps.getValue() || "-";
        }
      },
      {
        header: "Premium",
        accessorKey: "is_premium",
        enableColumnFilter: false,
        cell: (cellProps) => {
          return cellProps.getValue() ? <span className="badge bg-success">Premium</span> : <span className="badge bg-secondary">Gratis</span>;
        }
      },
      {
        header: "Deskripsi",
        accessorKey: "deskripsi",
        enableColumnFilter: false,
      },
      {
        header: "Gambar",
        accessorKey: "gambar_url",
        enableColumnFilter: false,
        cell: (cellProps) => {
          const imageUrl = cellProps.getValue();
          return imageUrl ? (
            <img src={imageUrl} alt="Paket Gambar" className="rounded avatar-sm" onError={(e) => e.target.src = 'https://placehold.co/50x50/DDDDDD/000000?text=No+Image'} />
          ) : (
            <img src='https://placehold.co/50x50/DDDDDD/000000?text=No+Image' alt="No Image" className="rounded avatar-sm" />
          );
        }
      },
      {
        header: "Jenis Seleksi",
        accessorKey: "jenis_seleksi.nama_seleksi",
        enableColumnFilter: false,
        cell: (cellProps) => {
          return cellProps.row.original.jenis_seleksi ? cellProps.row.original.jenis_seleksi.nama_seleksi : "-";
        }
      },
      {
        header: 'Created At',
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cellProps) => {
          const rawDate = cellProps.getValue();
          if (rawDate && rawDate !== "0001-01-01T00:00:00Z") {
            const date = new Date(rawDate);
            if (!isNaN(date.getTime())) {
              return date.toISOString().split('T')[0];
            }
          }
          return "-";
        }
      },
    {
      header: 'Action',
      enableColumnFilter: false,
      cell: (cellProps) => (
      <div className="hstack gap-2">
        {/* Tombol untuk Tryout */}
        {(cellProps.row.original.tipe_konten?.tipe_konten === 'tryout' || 
          cellProps.row.original.tipe_konten?.tipe_konten === 'pembahasan' ||
          cellProps.row.original.tipe_konten?.tipe_konten === 'kuis' ||
          cellProps.row.original.tipe_konten?.tipe_konten === 'belajar' ||
          cellProps.row.original.tipe_konten?.tipe_konten === 'simulasi' ||
          cellProps.row.original.tipe_konten?.tipe_konten === 'latihan' 
        ) && (
          <Link
           to={`/paket-detail-tryout?id_paket=${cellProps.row.original.id_paket}&id_tipe_konten=${cellProps.row.original.id_tipe_konten}&id_jenis_seleksi=${cellProps.row.original.id_jenis_seleksi}`}

            className="btn btn-sm btn-soft-primary"
            id={`detailtooltip-${cellProps.row.original.id_paket}`}
          >
            <i className="mdi mdi-plus" />
            <UncontrolledTooltip placement="top" target={`detailtooltip-${cellProps.row.original.id_paket}`}>
              {cellProps.row.original.tipe_konten?.tipe_konten === 'tryout'
                ? "Add Sub Paket Tryout"
                : cellProps.row.original.tipe_konten?.tipe_konten === 'pembahasan'
                  ? "Add Sub Paket Pembahasan"
                  : cellProps.row.original.tipe_konten?.tipe_konten === 'kuis'
                  ? "Add Sub Paket Kuis"
                  : cellProps.row.original.tipe_konten?.tipe_konten === 'belajar'
                    ? "Add Sub Paket Belajar"
                    : "-"}
            </UncontrolledTooltip>

          </Link>
        )}

        {/* Tombol Edit dan Delete */}
        <Link
          to="#"
          className="btn btn-sm btn-soft-info"
          onClick={() => openEditModal(cellProps.row.original)}
          id={`edittooltip-${cellProps.row.original.id_paket}`}
        >
          <i className="mdi mdi-pencil-outline" />
          <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id_paket}`}>
            Edit
          </UncontrolledTooltip>
        </Link>
        <Link
          to="#"
          className="btn btn-sm btn-soft-danger"
          onClick={() => onClickDelete(cellProps.row.original)}
          id={`deletetooltip-${cellProps.row.original.id_paket}`}
        >
          <i className="mdi mdi-delete-outline" />
          <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id_paket}`}>
            Delete
          </UncontrolledTooltip>
        </Link>
      </div>
    )
    }
    ],
    []
  );

  // Komponen kustom untuk paginasi (tetap sama)
  const CustomPagination = () => {
    const { page, last_page, total, per_page } = pagination;

    const getPageNumbers = () => {
      const pages = [];
      const maxVisiblePages = 5;
      let startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2));
      let endPage = Math.min(last_page, startPage + maxVisiblePages - 1);

      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <PaginationItem key={i} active={i === page}>
            <PaginationLink onClick={() => fetchData(i, per_page, filters)}>
              {i}
            </PaginationLink>
          </PaginationItem>
        );
      }

      return pages;
    };

    return (
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div className="text-muted">
          Menampilkan <span className="fw-semibold">{((page - 1) * per_page) + 1}</span> sampai{' '}
          <span className="fw-semibold">{Math.min(page * per_page, total)}</span> dari total{' '}
          <span className="fw-semibold">{total}</span> entri
        </div>

        <div className="d-flex align-items-center">
          <Pagination className="pagination pagination-rounded mb-0">
            <PaginationItem disabled={page === 1}>
              <PaginationLink
                previous
                onClick={() => page > 1 && fetchData(page - 1, per_page, filters)}
              >
                &lt;
              </PaginationLink>
            </PaginationItem>

            {getPageNumbers()}

            <PaginationItem disabled={page === last_page}>
              <PaginationLink
                next
                onClick={() => page < last_page && fetchData(page + 1, per_page, filters)}
              >
                &gt;
              </PaginationLink>
            </PaginationItem>
          </Pagination>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleConfirmDelete}
        onCloseClick={handleCloseDeleteModal}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Master Data" breadcrumbItem="Master Paket" />
          {
            loading ? <Spinners setLoading={setLoading} />
              :
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center justify-content-between">
                      <h5 className="mb-0 card-title flex-grow-1">List Paket</h5>
                      <div className="d-flex align-items-center">
                        <Button color="primary" onClick={openAddModal}>
                          <i className="mdi mdi-plus me-1"></i>
                          Tambah
                        </Button>
                      </div>
                    </div>
                  </CardBody>
                  <CardBody>
                    <h5 className="mb-3">Filter Paket</h5>
                    <Row className="mb-3 align-items-end">
                      <Col md="3">
                        <div className="mb-3">
                          <Label htmlFor="filter_id_tipe_konten">Tipe Konten</Label>
                          <Input
                            name="id_tipe_konten"
                            type="select"
                            className="form-select"
                            id="filter_id_tipe_konten"
                            onChange={handleFilterChange}
                            value={filters.id_tipe_konten}
                            disabled={loadingTipeKontenOptions}
                          >
                            <option value="">Semua Tipe Konten</option>
                            {loadingTipeKontenOptions ? (
                              <option disabled>Memuat data...</option>
                            ) : (
                              tipeKontenOptions.map((option) => (
                                <option key={option.id_tipe_konten} value={option.id_tipe_konten}>
                                  {option.tipe_konten}
                                </option>
                              ))
                            )}
                          </Input>
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="mb-3">
                          <Label htmlFor="filter_id_jenis_seleksi">Jenis Seleksi</Label>
                          <Input
                            name="id_jenis_seleksi"
                            type="select"
                            className="form-select"
                            id="filter_id_jenis_seleksi"
                            onChange={handleFilterChange}
                            value={filters.id_jenis_seleksi}
                            disabled={loadingJenisSeleksiOptions}
                          >
                            <option value="">Semua Jenis Seleksi</option>
                            {loadingJenisSeleksiOptions ? (
                              <option disabled>Memuat data...</option>
                            ) : (
                              jenisSeleksiOptions.map((option) => (
                                <option key={option.id_jenis_seleksi} value={option.id_jenis_seleksi}>
                                  {option.nama_seleksi}
                                </option>
                              ))
                            )}
                          </Input>
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="mb-3">
                          <Button color="danger" outline onClick={clearFilters} className="me-2">
                            Reset Filter
                          </Button>
                        </div>
                      </Col>
                    </Row>

                    <TableContainer
                      columns={columns}
                      data={data}
                      isGlobalFilter={false}
                      isPagination={false}
                      customPageSize={pagination.per_page}
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                    />
                    <CustomPagination />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          }

          {/* Modal untuk Tambah/Edit Paket */}
          <Modal isOpen={modal} toggle={() => setModal(false)}>
            <ModalHeader toggle={() => setModal(false)} tag="h4">
              {!!isEdit ? "Edit Paket" : "Tambah Paket"}
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={validation.handleSubmit}>
                <Row>
                  <Col md="12">
                    <div className="mb-3">
                      <Label>Nama Paket</Label>
                      <Input
                        name="nama_paket"
                        type="text"
                        placeholder="Nama Paket"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.nama_paket || ""}
                        invalid={!!(validation.touched.nama_paket && validation.errors.nama_paket)}
                      />
                      <FormFeedback>{validation.errors.nama_paket}</FormFeedback>
                    </div>

                    <div className="mb-3">
                      <Label htmlFor="durasi_menit">Durasi (Menit)</Label>
                      <Input
                        name="durasi_menit"
                        type="number"
                        placeholder="Durasi dalam menit (misal: 60)"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.durasi_menit || ""}
                        invalid={!!(validation.touched.durasi_menit && validation.errors.durasi_menit)}
                      />
                      <FormFeedback>{validation.errors.durasi_menit}</FormFeedback>
                    </div>

                    <div className="mb-3">
                      <Label>Deskripsi</Label>
                      <Input
                        name="deskripsi"
                        type="textarea"
                        rows="3"
                        placeholder="Deskripsi (Opsional)"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.deskripsi || ""}
                        invalid={!!(validation.touched.deskripsi && validation.errors.deskripsi)}
                      />
                      <FormFeedback>{validation.errors.deskripsi}</FormFeedback>
                    </div>

                    <div className="mb-3">
                      <Label htmlFor="gambar_url">URL Gambar</Label>
                      <Input
                        name="gambar_url"
                        type="text"
                        placeholder="URL Gambar (Opsional)"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.gambar_url || ""}
                        invalid={!!(validation.touched.gambar_url && validation.errors.gambar_url)}
                      />
                      <FormFeedback>{validation.errors.gambar_url}</FormFeedback>
                    </div>

                    {/* Form Input Tipe Konten dalam Modal */}
                    <div className="mb-3">
                      <Label htmlFor="id_tipe_konten">Tipe Konten</Label>
                      <Input
                        name="id_tipe_konten"
                        type="select"
                        className="form-select"
                        onChange={(e) => {
                          validation.handleChange(e); // Update Formik state
                          // Kosongkan id_jenis_seleksi saat id_tipe_konten berubah
                          validation.setFieldValue("id_jenis_seleksi", "");
                          console.log("DEBUG: Modal - id_tipe_konten changed:", e.target.value); // DEBUG LOG
                          console.log("DEBUG: Modal - validation.values.id_tipe_konten after change (may be slightly delayed):", validation.values.id_tipe_konten); // DEBUG LOG
                          // fetchJenisSeleksiOptions akan dipicu oleh useEffect saat validation.values.id_tipe_konten berubah
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.id_tipe_konten || ""}
                        invalid={!!(validation.touched.id_tipe_konten && validation.errors.id_tipe_konten)}
                        disabled={loadingTipeKontenOptions}
                      >
                        <option value="">Pilih Tipe Konten</option>
                        {loadingTipeKontenOptions ? (
                          <option disabled>Memuat data...</option>
                        ) : (
                          tipeKontenOptions.map((option) => (
                            <option key={option.id_tipe_konten} value={option.id_tipe_konten}>
                              {option.tipe_konten}
                            </option>
                          ))
                        )}
                      </Input>
                      <FormFeedback>{validation.errors.id_tipe_konten}</FormFeedback>
                    </div>

                    {/* Form Input Jenis Seleksi dalam Modal */}
                    <div className="mb-3">
                      <Label htmlFor="id_jenis_seleksi">Jenis Seleksi</Label>
                      <Input
                        name="id_jenis_seleksi"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.id_jenis_seleksi || ""}
                        invalid={!!(validation.touched.id_jenis_seleksi && validation.errors.id_jenis_seleksi)}
                        disabled={loadingJenisSeleksiOptions}
                      >
                        <option value="">Pilih Jenis Seleksi</option>
                        {loadingJenisSeleksiOptions ? (
                          <option disabled>Memuat data...</option>
                        ) : (
                          jenisSeleksiOptions.map((option) => (
                            <option key={option.id_jenis_seleksi} value={option.id_jenis_seleksi}>
                              {option.nama_seleksi}
                            </option>
                          ))
                        )}
                      </Input>
                      <FormFeedback>{validation.errors.id_jenis_seleksi}</FormFeedback>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <FormGroup check className="mb-3">
                      <Input
                        type="checkbox"
                        className="form-check-input"
                        name="is_premium"
                        id="is_premium"
                        checked={validation.values.is_premium}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                      />
                      <Label htmlFor="is_premium" className="form-check-label">Is Premium</Label>
                    </FormGroup>
                    {validation.touched.is_premium && validation.errors.is_premium ? (
                      <div className="text-danger">{validation.errors.is_premium}</div>
                    ) : null}
                  </Col>
                </Row>


                {/* Conditional fields for video type content */}
                {parseInt(validation.values.id_tipe_konten) === 8 && ( // Assuming 3 is the ID for "Video"
                  <>
                    <hr className="my-4" />
                    <h5 className="mb-3">Detail Video (Opsional)</h5>
                    <div className="mb-3">
                      <Label htmlFor="url_video">URL Video</Label>
                      <Input
                        name="url_video"
                        type="text"
                        placeholder="URL Video"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.url_video || ""}
                      />
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="durasi_detik">Durasi (Detik)</Label>
                      <Input
                        name="durasi_detik"
                        type="number"
                        placeholder="Durasi dalam detik"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.durasi_detik || ""}
                      />
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="thumbnail_url">URL Thumbnail Video</Label>
                      <Input
                        name="thumbnail_url"
                        type="text"
                        placeholder="URL Thumbnail Video"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.thumbnail_url || ""}
                      />
                    </div>
                  </>
                )}

                <Row>
                  <Col>
                    <div className="text-end">
                      <Button type="submit" color="primary">
                        {isEdit ? "Update" : "Tambah"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default MasterPaket;